import { FeedItemDto, PublicationType } from 'generated/CoreApi_v1';
import React from 'react';
import { PublicationTopicsBox } from './PublicationTopicsBox';
import { PublicationViewsBox } from './PublicationViewsBox';
import { SeeAlsoBox } from './SeeAlsoBox';
import { TranscriptionBox } from './TranscriptionBox';

export function RightPanelContentPage(publication: FeedItemDto): React.ReactElement[] {
    const arr: React.ReactElement[] = [];

    if (publication.publicationType == PublicationType.Post || publication.publicationType == PublicationType.Question)
        arr.push(<TranscriptionBox key="TranscriptionBox" publication={publication} />);

    arr.push(<SeeAlsoBox key="SeeAlsoBox" publicationId={publication.masterPublication?.publicationId ?? publication.publicationId} />);
    arr.push(<PublicationTopicsBox key="PublicationTopicsBox" publication={publication} />);
    arr.push(<PublicationViewsBox key="PublicationViewsBox" publication={publication} />);

    return arr;
}
